import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEN from './locales/en/common.json';
import menuEN from './locales/en/menu.json';
import bookingEN from './locales/en/booking.json';
import bookingPickerEN from './locales/en/booking_picker.json';
import uploaderEN from './locales/en/uploader.json';
import parcelsTableEN from './locales/en/parcels_table.json';
import parcelModalEN from './locales/en/parcel_modal.json';
import parcelAddStatusModalEN from './locales/en/parcel_add_status_modal.json';
import parcelRemoveStatusModalEN from './locales/en/parcel_remove_status_modal.json';
import parcelsInBatchEN from './locales/en/parcels_in_batch.json';
import batchAndParcelsSearchEN from './locales/en/batch_and_parcels_search.json';
import moveParcelModalEN from './locales/en/move_parcel_modal.json';
import removeParcelModalEN from './locales/en/remove_parcel_modal.json';
import InvoicesUploadEN from './locales/en/invoices_upload.json';
import ParcelsUploadEN from './locales/en/parcels_upload.json';
import UpdateMasterEN from './locales/en/update_master.json';
import SendMasterEN from './locales/en/send_master.json';
import TemplatesEN from './locales/en/templates.json';
import ParcelIssuesEN from './locales/en/parcel_issues.json';
import ParcelsHeaderEN from './locales/en/parcels_header.json';
import TrackingEN from './locales/en/tracking.json';
import DropOffPointEN from './locales/en/drop_off_point.json';
import SmsOptEN from './locales/en/sms_opt.json';
import BuyerDetailsUpdateEN from './locales/en/buyer_details_update.json';


import commonCN from './locales/cn/common.json';
import menuCN from './locales/cn/menu.json';
import bookingCN from './locales/cn/booking.json';
import bookingPickerCN from './locales/cn/booking_picker.json';
import uploaderCN from './locales/cn/uploader.json';
import parcelsTableCN from './locales/cn/parcels_table.json';
import parcelModalCN from './locales/cn/parcel_modal.json';
import parcelAddStatusModalCN from './locales/cn/parcel_add_status_modal.json';
import parcelRemoveStatusModalCN from './locales/cn/parcel_remove_status_modal.json';
import parcelsInBatchCN from './locales/cn/parcels_in_batch.json';
import batchAndParcelsSearchCN from './locales/cn/batch_and_parcels_search.json';
import moveParcelModalCN from './locales/cn/move_parcel_modal.json';
import removeParcelModalCN from './locales/cn/remove_parcel_modal.json';
import InvoicesUploadCN from './locales/cn/invoices_upload.json';
import ParcelsUploadCN from './locales/cn/parcels_upload.json';
import UpdateMasterCN from './locales/cn/update_master.json';
import SendMasterCN from './locales/cn/send_master.json';
import TemplatesCN from './locales/cn/templates.json';
import ParcelIssuesCN from './locales/cn/parcel_issues.json';
import ParcelsHeaderCN from './locales/cn/parcels_header.json';

import TrackingHE from './locales/he/tracking.json';
import DropOffPointHE from './locales/he/drop_off_point.json';
import SmsOptHE from './locales/he/sms_opt.json';
import BuyerDetailsUpdateHE from './locales/he/buyer_details_update.json';
import payInspectionHE from './locales/he/pay_inspection.json';
import thanksHE from './locales/he/thanks.json';
import noticeMessageHE from './locales/he/notice_message.json';


i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  //.use(Backend)

  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: true,
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        common: commonEN,
        menu: menuEN,
        booking: bookingEN,
        booking_picker: bookingPickerEN,
        uploader: uploaderEN,
        parcels_table: parcelsTableEN,
        parcel_modal: parcelModalEN,
        move_parcel_modal: moveParcelModalEN,
        remove_parcel_modal: removeParcelModalEN,
        parcel_add_status_modal: parcelAddStatusModalEN,
        parcel_remove_status_modal: parcelRemoveStatusModalEN,
        parcels_in_batch: parcelsInBatchEN,
        batch_and_parcels_search: batchAndParcelsSearchEN,
        invoices_upload: InvoicesUploadEN,
        parcels_upload: ParcelsUploadEN,
        update_master: UpdateMasterEN,
        send_master: SendMasterEN,
        templates: TemplatesEN,
        parcel_issues: ParcelIssuesEN,
        parcels_header: ParcelsHeaderEN,
        tracking: TrackingEN,
        dropOffPoint: DropOffPointEN,
        sms_opt: SmsOptEN,
        buyer_details_update: BuyerDetailsUpdateEN

      },
      cn: {
        common: commonCN,
        menu: menuCN,
        booking: bookingCN,
        booking_picker: bookingPickerCN,
        uploader: uploaderCN,
        parcels_table: parcelsTableCN,
        parcel_modal: parcelModalCN,
        move_parcel_modal: moveParcelModalCN,
        remove_parcel_modal: removeParcelModalCN,
        parcel_add_status_modal: parcelAddStatusModalCN,
        parcel_remove_status_modal: parcelRemoveStatusModalCN,
        parcels_in_batch: parcelsInBatchCN,
        batch_and_parcels_search: batchAndParcelsSearchCN,
        invoices_upload: InvoicesUploadCN,
        parcels_upload: ParcelsUploadCN,
        update_master: UpdateMasterCN,
        send_master: SendMasterCN,
        templates: TemplatesCN,
        parcel_issues: ParcelIssuesCN,
        parcels_header: ParcelsHeaderCN,
      },
      he: {
        tracking: TrackingHE,
        dropOffPoint: DropOffPointHE,
        sms_opt: SmsOptHE,
        buyer_details_update: BuyerDetailsUpdateHE,
        payInspection: payInspectionHE,
        thanks: thanksHE,
        notice_message: noticeMessageHE
      },
    },
  });

export default i18n;
